// Generated by purs version 0.11.7
"use strict";
var Data_Array = require("../Data.Array");
var Data_Eq = require("../Data.Eq");
var Data_Foldable = require("../Data.Foldable");
var Data_Function = require("../Data.Function");
var Data_Functor = require("../Data.Functor");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra");
var Data_Maybe = require("../Data.Maybe");
var Data_Ord = require("../Data.Ord");
var Data_Ring = require("../Data.Ring");
var Data_Semigroup = require("../Data.Semigroup");
var Data_Semiring = require("../Data.Semiring");
var Data_Show = require("../Data.Show");
var Data_String = require("../Data.String");
var Data_Tuple = require("../Data.Tuple");
var Prelude = require("../Prelude");
var PrestoDOM_Core = require("../PrestoDOM.Core");
var PrestoDOM_Elements = require("../PrestoDOM.Elements");
var PrestoDOM_Properties = require("../PrestoDOM.Properties");
var PrestoDOM_Types = require("../PrestoDOM.Types");
var PrestoDOM_Types_DomAttributes = require("../PrestoDOM.Types.DomAttributes");
var Sokoban_Types = require("../Sokoban.Types");
var renderEntity = function (entity) {
    return PrestoDOM_Elements.linearLayout([ PrestoDOM_Properties.width(new PrestoDOM_Types_DomAttributes.V(entity.w)), PrestoDOM_Properties.height(new PrestoDOM_Types_DomAttributes.V(entity.h)), PrestoDOM_Properties.padding("1,1,1,1"), PrestoDOM_Properties.margin(Data_Show.show(Data_Show.showInt)(entity.x) + ("," + (Data_Show.show(Data_Show.showInt)(entity.y) + ",0,0"))), PrestoDOM_Properties.gravity("center") ])([ PrestoDOM_Elements.linearLayout([ PrestoDOM_Properties.width((function () {
        var $4 = entity.t === ".";
        if ($4) {
            return new PrestoDOM_Types_DomAttributes.V(20);
        };
        return PrestoDOM_Types_DomAttributes.Match_Parent.value;
    })()), PrestoDOM_Properties.height((function () {
        var $5 = entity.t === ".";
        if ($5) {
            return new PrestoDOM_Types_DomAttributes.V(20);
        };
        return PrestoDOM_Types_DomAttributes.Match_Parent.value;
    })()), PrestoDOM_Properties.background(entity.c), PrestoDOM_Properties.stroke("1,#777777"), PrestoDOM_Properties.cornerRadius("10") ])([  ]) ]);
};
var renderLevel = function (state) {
    return PrestoDOM_Elements.relativeLayout([ PrestoDOM_Properties.width(PrestoDOM_Types_DomAttributes.Match_Parent.value), PrestoDOM_Properties.height(PrestoDOM_Types_DomAttributes.Match_Parent.value), PrestoDOM_Properties.background("#10733a"), PrestoDOM_Properties.cornerRadius("10"), PrestoDOM_Properties.padding("25,25,0,0") ])([ PrestoDOM_Elements.relativeLayout([ PrestoDOM_Properties.width(PrestoDOM_Types_DomAttributes.Match_Parent.value), PrestoDOM_Properties.height(PrestoDOM_Types_DomAttributes.Match_Parent.value) ])(Data_Functor.map(Data_Functor.functorArray)(renderEntity)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(state.world.walls)(state.world.areas))(state.world.bags))), renderEntity(state.world.soko) ]);
};
var levelWidth = function (level) {
    return Data_Maybe.fromMaybe(0)(Data_Foldable.maximum(Data_Ord.ordInt)(Data_Foldable.foldableArray)(Data_Functor.map(Data_Functor.functorArray)(Data_Array.length)(level)));
};
var padLevel = function (level) {
    var lengthDiff = function (r) {
        return levelWidth(level) - Data_Array.length(r) | 0;
    };
    var padLevelRow = function (r) {
        return Data_Semigroup.append(Data_Semigroup.semigroupArray)(r)(Data_Functor.map(Data_Functor.functorArray)(function (v) {
            return " ";
        })(Data_Array.range(0)(lengthDiff(r))));
    };
    return Data_Functor.map(Data_Functor.functorArray)(padLevelRow)(level);
};
var levelHeight = function (level) {
    return Data_Array.length(level);
};
var createLevelData = function (level) {
    return padLevel(Data_Functor.map(Data_Functor.functorArray)(Data_String.toCharArray)(Data_Array.filter(function (s) {
        return !(Data_String.trim(s) === "");
    })(Data_String.split("\x0a")(Data_String.replaceAll("\x0d")("")(level)))));
};
var createEntity = function (v) {
    return function (c) {
        var yPos = v.value1 * 50 | 0;
        var xPos = v.value0 * 50 | 0;
        var color = (function () {
            if (c === "#") {
                return "#212020";
            };
            if (c === ".") {
                return "#690000";
            };
            if (c === "$") {
                return "#823b05";
            };
            if (c === "@") {
                return "#e58e26";
            };
            return "error";
        })();
        return {
            x: xPos,
            y: yPos,
            w: 50,
            h: 50,
            c: color,
            t: c,
            nextPos: new Sokoban_Types.Coord(xPos, yPos)
        };
    };
};
var createEntities = function (v) {
    if (v.value1 === "+") {
        return [ createEntity(v.value0)("@"), createEntity(v.value0)(".") ];
    };
    if (v.value1 === "*") {
        return [ createEntity(v.value0)("$"), createEntity(v.value0)(".") ];
    };
    return [ createEntity(v.value0)(v.value1) ];
};
var createWorld = function (level) {
    var grid = function (w) {
        return function (h) {
            return Data_Array.concatMap(function (y) {
                return Data_Functor.map(Data_Functor.functorArray)(function (x) {
                    return new Sokoban_Types.Coord(x, y);
                })(Data_Array.range(0)(w - 1 | 0));
            })(Data_Array.range(0)(h - 1 | 0));
        };
    };
    var entities = Data_Array.concatMap(createEntities)(Data_Array.filter(function (v) {
        return !(v.value1 === " ");
    })(Data_Array.zip(grid(levelWidth(level))(levelHeight(level)))(Data_Foldable.foldl(Data_Foldable.foldableArray)(Data_Semigroup.append(Data_Semigroup.semigroupArray))([  ])(level))));
    return {
        soko: Data_Maybe.fromMaybe({
            x: 0,
            y: 0,
            w: 0,
            h: 0,
            c: "",
            t: "@",
            nextPos: new Sokoban_Types.Coord(0, 0)
        })(Data_Array.index(Data_Array.filter(function (e) {
            return e.t === "@";
        })(entities))(0)),
        walls: Data_Array.filter(function (e) {
            return e.t === "#";
        })(entities),
        bags: Data_Array.filter(function (e) {
            return e.t === "$";
        })(entities),
        areas: Data_Array.filter(function (e) {
            return e.t === ".";
        })(entities),
        width: (levelWidth(level) - 1 | 0) * 50 | 0,
        height: levelHeight(level) * 50 | 0
    };
};
module.exports = {
    createWorld: createWorld,
    createEntities: createEntities,
    createEntity: createEntity,
    levelHeight: levelHeight,
    levelWidth: levelWidth,
    createLevelData: createLevelData,
    padLevel: padLevel,
    renderLevel: renderLevel,
    renderEntity: renderEntity
};



//////////////////
// WEBPACK FOOTER
// ./output/Sokoban.Level/index.js
// module id = 193
// module chunks = 0